// extracted by mini-css-extract-plugin
export var createdDate = "_ji-1";
export var divider = "_ji-2";
export var headerDivider = "_ji-3";
export var messagesCard = "_ji-0";
export var messagesContainer = "_ji-6";
export var messagesContainerWrapper = "_ji-4";
export var showLeftPanelButton = "_ji-8";
export var topButtons = "_ji-7";
export var withPadding = "_ji-5";